import React, {
    useMemo,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import Swal from 'sweetalert2';


import HeaderUno
    from '../Metodos/Compartidos/HeaderUno';

import HeaderDos
    from '../Metodos/Compartidos/HeaderDos';

import SelectorUbicacion
    from '../Metodos/Compartidos/Ubicacion/SelectorUbicacion';

import CampoEditablePaciente
    from '../Escritorio/Pacientes/CampoEditablePaciente';

import ModalInvitarPaciente
    from '../Escritorio/Pacientes/ModalInvitarPaciente';

import {
    enviarInvitacionPacienteAction
} from '../../actions/invitarPacienteActions';

import {
    cargarPacientesAction
} from '../../actions/cargarPacientesActions';

import {
    solicitudNuevoProfesionalAction
} from '../../actions/solicitudNuevoProfesionalActions';

import useConfigAuth
    from '../../Hooks/useConfigAuth';

import {
    editarPacienteAction
} from '../../actions/editarPacienteActions';


import Alertas
    from '../Metodos/Compartidos/Alertas';


import {
    ContenedorPrincipal
} from '../Css/MetodosCSS/StyledFormPacTemp';


import {

    ContenedorDatosPaciente,

    EncabezadoPaciente,
    InfoPacienteSuperior,
    DatoSuperior,
    EstadoPaciente,

    TarjetaDatosPaciente,

    SeccionDatosPaciente,
    EncabezadoSeccionDatos,
    TituloSeccionDatos,
    TextoSeccionDatos,

    SeparadorDatosPaciente,

    GridDatosPaciente,

    CabeceraTutoresDatos,

    BloqueUbicacionDato,
    EncabezadoUbicacionDato,
    TituloUbicacionDato,

    ResumenUbicacion,
    ItemUbicacion,
    UbicacionVacia,

    AvisoDatosYogen,
    TextoAvisoYogen,
    BotonAyudaDatos,

    BotonEditarCampo,
    AccionesCampo,
    BotonConfirmarCampo,
    BotonCancelarCampo,

    TextoErrorDato,

    AccionesAvisoDatosYogen,
    BotonInvitarPaciente,
    BotonSolicitarVinculacion,

    EstadoInvitacionBox,
    CabeceraEstadoInvitacion,
    TituloEstadoInvitacion,
    BadgeEstadoInvitacion,
    EmailEstadoInvitacion,
    DetalleEstadoInvitacion,
    MetaEstadoInvitacion

} from '../Css/StyledDatosPaciente';


/*
========================================
OPCIONES
========================================
*/

const OPCIONES_SEXO = [

    {
        valor:
            'Masculino',

        texto:
            'Masculino'
    },

    {
        valor:
            'Femenino',

        texto:
            'Femenino'
    }

];


const OPCIONES_REPITIO = [

    {
        valor:
            'Si',

        texto:
            'Sí'
    },

    {
        valor:
            'No',

        texto:
            'No'
    }

];


/*
========================================
DATOS MÍNIMOS PARA INVITACIÓN
========================================
*/

const CAMPOS_MINIMOS_INVITACION = {

    nombre:
        'nombre del paciente',

    apellido:
        'apellido del paciente',

    fecha_nacimiento:
        'fecha de nacimiento',

    email:
        'email del paciente',

    nombre_1:
        'nombre del Tutor 1',

    apellido_1:
        'apellido del Tutor 1',

    email_1:
        'email del Tutor 1'

};


/*
========================================
OBLIGATORIOS CREACIÓN
========================================
*/

const CAMPOS_OBLIGATORIOS_CREACION =
    new Set([

        'nombre',
        'apellido',
        'email',
        'curso',
        'repitio_anio'

    ]);


/*
========================================
PACIENTE YA VINCULADO
========================================
*/

const CAMPOS_EDITABLES_VINCULADO =
    new Set([

        'cobertura_medica',
        'plan',
        'numero_afiliado',
        'motivo_consulta'

    ]);


/*
========================================
CONFIGURACIÓN CAMPOS PACIENTE
========================================
*/

const CAMPOS_DATOS_PACIENTE = [

    {
        nombre:
            'nombre',

        label:
            'Nombre'
    },

    {
        nombre:
            'apellido',

        label:
            'Apellido'
    },

    {
        nombre:
            'fecha_nacimiento',

        label:
            'Fecha de nacimiento',

        tipo:
            'date'
    },

    {
        nombre:
            'edad',

        label:
            'Edad',

        editable:
            false,

        obtenerValor:
            paciente => {

                if (
                    paciente.edad === null ||
                    paciente.edad === undefined
                ) {

                    return '';

                }


                return `${paciente.edad} años`;

            }
    },

    {
        nombre:
            'sexo',

        label:
            'Sexo',

        opciones:
            OPCIONES_SEXO
    },

    {
        nombre:
            'email',

        label:
            'Email',

        tipo:
            'email'
    },

    {
        nombre:
            'nacionalidad',

        label:
            'Nacionalidad'
    },

    {
        nombre:
            'dni',

        label:
            'Documento'
    }

];


/*
========================================
ESCOLARIDAD
========================================
*/

const CAMPOS_ESCOLARIDAD = [

    {
        nombre:
            'colegio',

        label:
            'Colegio'
    },

    {
        nombre:
            'curso',

        label:
            'Curso / grado'
    },

    {
        nombre:
            'repitio_anio',

        label:
            '¿Repitió algún año?',

        opciones:
            OPCIONES_REPITIO
    }

];


/*
========================================
COBERTURA
========================================
*/

const CAMPOS_COBERTURA = [

    {
        nombre:
            'cobertura_medica',

        label:
            'Obra social / cobertura'
    },

    {
        nombre:
            'plan',

        label:
            'Plan'
    },

    {
        nombre:
            'numero_afiliado',

        label:
            'Número de afiliado'
    }

];


/*
========================================
INFORMACIÓN CLÍNICA
========================================
*/

const CAMPOS_CLINICOS = [

    {
        nombre:
            'medico',

        label:
            'Médico'
    },

    {
        nombre:
            'medicacion',

        label:
            'Medicación'
    },

    {
        nombre:
            'diagnostico_previo',

        label:
            'Diagnóstico previo',

        completo:
            true
    },

    {
        nombre:
            'motivo_consulta',

        label:
            'Motivo de consulta',

        completo:
            true
    },

    {
        nombre:
            'terapias_actuales',

        label:
            'Terapias actuales',

        completo:
            true
    },

    {
        nombre:
            'hermanos',

        label:
            'Hermanos',

        completo:
            true
    }

];


/*
========================================
TUTORES
========================================
*/

const CAMPOS_TUTORES = [

    {
        nombre:
            'nombre_1',

        label:
            'Nombre'
    },

    {
        nombre:
            'nombre_2',

        label:
            'Nombre'
    },

    {
        nombre:
            'apellido_1',

        label:
            'Apellido'
    },

    {
        nombre:
            'apellido_2',

        label:
            'Apellido'
    },

    {
        nombre:
            'fecha_nacimiento_1',

        label:
            'Fecha de nacimiento',

        tipo:
            'date'
    },

    {
        nombre:
            'fecha_nacimiento_2',

        label:
            'Fecha de nacimiento',

        tipo:
            'date'
    },

    {
        nombre:
            'edad_1',

        label:
            'Edad',

        editable:
            false,

        obtenerValor:
            paciente => {

                if (
                    paciente.edad_1 === null ||
                    paciente.edad_1 === undefined
                ) {

                    return '';

                }


                return `${paciente.edad_1} años`;

            }
    },

    {
        nombre:
            'edad_2',

        label:
            'Edad',

        editable:
            false,

        obtenerValor:
            paciente => {

                if (
                    paciente.edad_2 === null ||
                    paciente.edad_2 === undefined
                ) {

                    return '';

                }


                return `${paciente.edad_2} años`;

            }
    },

    {
        nombre:
            'telefono_1',

        label:
            'Teléfono',

        tipo:
            'tel'
    },

    {
        nombre:
            'telefono_2',

        label:
            'Teléfono',

        tipo:
            'tel'
    },

    {
        nombre:
            'email_1',

        label:
            'Email',

        tipo:
            'email'
    },

    {
        nombre:
            'email_2',

        label:
            'Email',

        tipo:
            'email'
    },

    {
        nombre:
            'nivel_estudios_1',

        label:
            'Nivel de estudios'
    },

    {
        nombre:
            'nivel_estudios_2',

        label:
            'Nivel de estudios'
    },

    {
        nombre:
            'profesion_1',

        label:
            'Profesión'
    },

    {
        nombre:
            'profesion_2',

        label:
            'Profesión'
    },

    {
        nombre:
            'ocupacion_1',

        label:
            'Ocupación'
    },

    {
        nombre:
            'ocupacion_2',

        label:
            'Ocupación'
    },

    {
        nombre:
            'estado_civil_1',

        label:
            'Estado civil'
    },

    {
        nombre:
            'estado_civil_2',

        label:
            'Estado civil'
    }

];


/*
========================================
FECHA PARA INPUT
========================================
*/

const convertirFechaParaInput = (
    valor
) => {

    if (
        !valor
    ) {

        return '';

    }


    const texto =
        String(
            valor
        );


    if (
        /^\d{4}-\d{2}-\d{2}/
            .test(
                texto
            )
    ) {

        return texto
            .slice(
                0,
                10
            );

    }


    const coincidencia =
        texto.match(
            /^(\d{2})\/(\d{2})\/(\d{4})$/
        );


    if (
        coincidencia
    ) {

        const [
            ,
            dia,
            mes,
            anio
        ] = coincidencia;


        return `${anio}-${mes}-${dia}`;

    }


    return '';

};


/*
========================================
UBICACIÓN PARA MOSTRAR
========================================
*/

const obtenerResumenUbicacion = ({

    ubicacion,
    paisLegacy,
    provinciaLegacy,
    departamentoLegacy,
    localidadLegacy

}) => {

    if (
        ubicacion &&
        typeof ubicacion === 'object'
    ) {

        if (
            ubicacion.pais_codigo ===
            'OTRO'
        ) {

            return [

                ubicacion.pais,
                ubicacion.provincia,
                ubicacion.localidad

            ].filter(
                Boolean
            );

        }


        const resultado =
            [];


        if (
            ubicacion.pais
        ) {

            resultado.push(
                ubicacion.pais
            );

        }


        const niveles =
            Object.values(
                ubicacion.niveles ||
                {}
            )
                .sort(
                    (
                        a,
                        b
                    ) =>
                        (
                            a.nivel ||
                            0
                        ) -
                        (
                            b.nivel ||
                            0
                        )
                );


        niveles.forEach(
            nivel => {

                const nombre =
                    nivel
                        ?.metadata
                        ?.nombre_mostrar ||
                    nivel
                        ?.nombre;


                if (
                    nombre
                ) {

                    resultado.push(
                        nombre
                    );

                }

            }
        );


        if (
            ubicacion
                .localidad_manual
        ) {

            resultado.push(
                ubicacion
                    .localidad_manual
            );

        }


        if (
            resultado.length > 0
        ) {

            return resultado;

        }

    }


    return [

        paisLegacy,
        provinciaLegacy,
        departamentoLegacy,
        localidadLegacy

    ].filter(
        Boolean
    );

};


/*
========================================
ESTADO DEL EMAIL DE INVITACIÓN
========================================
*/

const obtenerEstadoEmailInvitacion = (
    emailInvitacion
) => {

    if (
        !emailInvitacion
    ) {

        return null;

    }


    const estado =
        String(
            emailInvitacion.estado ||
            ''
        )
            .trim()
            .toUpperCase();


    const errorCode =
        String(
            emailInvitacion.error_code ||
            ''
        )
            .trim()
            .toUpperCase();


    if (
        estado ===
        'SPAM'
    ) {

        return {

            tipo:
                'error',

            titulo:
                'Marcado como spam',

            detalle:
                'El destinatario marcó el correo como spam. Conviene contactarlo por otro medio antes de volver a enviar.'

        };

    }


    if (
        estado ===
        'REBOTADO' ||
        estado ===
        'RECHAZADO'
    ) {

        return {

            tipo:
                'error',

            titulo:
                'Email rechazado',

            detalle:
                'El servidor de destino rechazó el correo. Revisá que la dirección de email sea correcta.'

        };

    }


    if (
        estado ===
        'ERROR'
    ) {

        if (
            errorCode ===
            'EMAIL_INVALIDO'
        ) {

            return {

                tipo:
                    'error',

                titulo:
                    'Email inválido',

                detalle:
                    'La dirección de email no tiene un formato válido. Revisala antes de volver a enviar la invitación.'

            };

        }


        if (
            errorCode ===
            'EMAIL_RECHAZADO'
        ) {

            return {

                tipo:
                    'error',

                titulo:
                    'Email rechazado',

                detalle:
                    'El servidor de destino rechazó el correo. Revisá que la dirección cargada sea correcta.'

            };

        }


        return {

            tipo:
                'error',

            titulo:
                'Error de envío',

            detalle:
                'No se pudo completar el envío de la invitación.'

        };

    }


    if (
        estado ===
        'REINTENTO_PENDIENTE'
    ) {

        return {

            tipo:
                'advertencia',

            titulo:
                'Reintentando envío',

            detalle:
                'El primer intento tuvo un inconveniente. YÖGEN realizará un nuevo intento automáticamente.'

        };

    }


    if (
        estado ===
        'DEMORADO'
    ) {

        return {

            tipo:
                'advertencia',

            titulo:
                'Entrega demorada',

            detalle:
                'El servidor de destino informó una demora. El correo todavía puede ser entregado.'

        };

    }


    if (
        estado ===
        'ENTREGADO'
    ) {

        return {

            tipo:
                'exito',

            titulo:
                'Email entregado',

            detalle:
                'El servidor de destino confirmó que el correo fue entregado correctamente.'

        };

    }


    if (
        estado ===
        'ENVIADO' ||
        estado ===
        'ENVIADA'
    ) {

        return {

            tipo:
                'info',

            titulo:
                'Email enviado',

            detalle:
                'El correo fue enviado. Todavía estamos esperando la confirmación de entrega.'

        };

    }


    if (
        estado ===
        'PENDIENTE' ||
        estado ===
        'PROGRAMADA'
    ) {

        return {

            tipo:
                'advertencia',

            titulo:
                'Pendiente de envío',

            detalle:
                'La invitación fue creada correctamente y el correo está pendiente de envío.'

        };

    }


    if (
        estado ===
        'CANCELADO'
    ) {

        return {

            tipo:
                'neutral',

            titulo:
                'Envío cancelado',

            detalle:
                'El envío de esta invitación fue cancelado.'

        };

    }


    return {

        tipo:
            'neutral',

        titulo:
            'Invitación registrada',

        detalle:
            'Existe un registro de envío para esta invitación.'

    };

};


/*
========================================
DATOS PACIENTE
========================================
*/

const DatosPaciente = () => {

    const dispatch =
        useDispatch();


    const [config] =
        useConfigAuth();


    /*
    ====================================
    REDUX
    ====================================
    */

    const alerta =
        useSelector(
            state =>
                state.alertas.alerta
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const emailProfesional =
        useSelector(
            state =>
                state.usuario.email
        );


    const pacientes =
        useSelector(
            state =>
                state
                    .informacion
                    .lista_pacientes
        );


    /*
    ====================================
    PACIENTE ACTUAL
    ====================================
    */

    const paciente =
        useMemo(
            () => {

                if (
                    !Array.isArray(
                        pacientes
                    )
                ) {

                    return null;

                }


                return pacientes
                    .find(
                        item =>
                            item.id_paciente ===
                            id_paciente
                    ) ||
                    null;

            },
            [
                pacientes,
                id_paciente
            ]
        );


    /*
    ====================================
    EDICIÓN
    ====================================
    */

    const [
        campoEditando,
        setCampoEditando
    ] = useState(null);


    const [
        valorEdicion,
        setValorEdicion
    ] = useState('');


    const [
        errorCampo,
        setErrorCampo
    ] = useState('');


    const [
        guardandoCampo,
        setGuardandoCampo
    ] = useState(false);


    /*
    ========================================
    INVITACIÓN PACIENTE
    ========================================
    */

    const [
        modalInvitacionAbierto,
        setModalInvitacionAbierto
    ] = useState(false);


    const [
        enviandoInvitacion,
        setEnviandoInvitacion
    ] = useState(false);


    const [
        errorInvitacion,
        setErrorInvitacion
    ] = useState('');


    /*
    ========================================
    SOLICITUD DE VINCULACIÓN
    ========================================
    */

    const [
        enviandoVinculacion,
        setEnviandoVinculacion
    ] = useState(false);


    const [
        errorVinculacion,
        setErrorVinculacion
    ] = useState('');


    /*
    ====================================
    ESTADO INVITACIÓN
    ====================================
    */

    const tieneHistorialInvitacion =
        Boolean(
            paciente
                ?.estado_email_invitacion
        );


    const tieneTiempoInvitacion =
        paciente
            ?.t_inv_restante !==
            null &&

        paciente
            ?.t_inv_restante !==
            undefined &&

        paciente
            ?.t_inv_restante !==
            '';


    const horasInvitacionRestantes =
        tieneTiempoInvitacion
            ?
            Number(
                paciente
                    ?.t_inv_restante
            )
            :
            null;


    const invitacionVigente =
        Boolean(

            paciente &&

            !paciente.paciente_id &&

            !paciente.email_app &&

            Number.isFinite(
                horasInvitacionRestantes
            ) &&

            horasInvitacionRestantes >
            0

        );


    const invitacionVencida =
        Boolean(

            paciente &&

            !paciente.paciente_id &&

            !paciente.email_app &&

            tieneHistorialInvitacion &&

            !invitacionVigente

        );


    const infoEstadoEmail =
        obtenerEstadoEmailInvitacion(
            paciente
                ?.estado_email_invitacion
        );


    const emailUltimaInvitacion =
        paciente
            ?.estado_email_invitacion
            ?.email ||
        paciente
            ?.email ||
        '';

    /*
    ====================================
    REENVÍO INMEDIATO
    ====================================

    REBOTADO / RECHAZADO:
        puede reenviarse aunque el email
        continúe siendo el mismo.

    EMAIL_INVALIDO:
        requiere corregir el email.

    SPAM:
        no permite reenvío inmediato.
    ====================================
    */

    const estadoEmailInvitacion =
        String(
            paciente
                ?.estado_email_invitacion
                ?.estado ||
            ''
        )
            .trim()
            .toUpperCase();


    const errorCodeEmailInvitacion =
        String(
            paciente
                ?.estado_email_invitacion
                ?.error_code ||
            ''
        )
            .trim()
            .toUpperCase();


    const emailRechazado =

        estadoEmailInvitacion ===
        'REBOTADO' ||

        estadoEmailInvitacion ===
        'RECHAZADO' ||

        (
            estadoEmailInvitacion ===
            'ERROR' &&

            errorCodeEmailInvitacion ===
            'EMAIL_RECHAZADO'
        );


    const emailInvalido =

        errorCodeEmailInvitacion ===
        'EMAIL_INVALIDO';


    const emailSpam =

        estadoEmailInvitacion ===
        'SPAM';


    const puedeReenviarInmediatamente =

        invitacionVigente &&

        emailRechazado;


    /*
    ====================================
    REGLA DE EDICIÓN
    ====================================
    */

    const puedeEditarCampo = (
        nombreCampo
    ) => {

        if (
            !paciente
        ) {

            return false;

        }


        if (
            !paciente.paciente_id
        ) {

            return true;

        }


        return CAMPOS_EDITABLES_VINCULADO
            .has(
                nombreCampo
            );

    };


    /*
    ====================================
    INICIAR EDICIÓN
    ====================================
    */

    const iniciarEdicion = (
        nombreCampo,
        valorActual,
        tipo = 'text'
    ) => {

        if (
            guardandoCampo
        ) {

            return;

        }


        setCampoEditando(
            nombreCampo
        );


        setErrorCampo(
            ''
        );


        if (
            tipo === 'date'
        ) {

            setValorEdicion(
                convertirFechaParaInput(
                    valorActual
                )
            );


            return;

        }


        setValorEdicion(
            valorActual ??
            ''
        );

    };


    /*
    ====================================
    CANCELAR EDICIÓN
    ====================================
    */

    const cancelarEdicion =
        () => {

            if (
                guardandoCampo
            ) {

                return;

            }


            setCampoEditando(
                null
            );


            setValorEdicion(
                ''
            );


            setErrorCampo(
                ''
            );

        };


    /*
    ====================================
    VALIDAR EMAIL DUPLICADO
    ====================================
    */

    const validarEmailDuplicado = (
        nombreCampo,
        nuevoValor
    ) => {

        if (
            ![
                'email',
                'email_1',
                'email_2'
            ].includes(
                nombreCampo
            )
        ) {

            return false;

        }


        const valorNuevo =
            String(
                nuevoValor ||
                ''
            )
                .trim()
                .toLowerCase();


        if (
            !valorNuevo
        ) {

            return false;

        }


        const valores = {

            email:
                paciente
                    ?.email,

            email_1:
                paciente
                    ?.email_1,

            email_2:
                paciente
                    ?.email_2

        };


        valores[
            nombreCampo
        ] =
            valorNuevo;


        const otrosEmails = [

            {
                nombre:
                    'email',

                valor:
                    valores.email
            },

            {
                nombre:
                    'email_1',

                valor:
                    valores.email_1
            },

            {
                nombre:
                    'email_2',

                valor:
                    valores.email_2
            },

            {
                nombre:
                    'email_profesional',

                valor:
                    emailProfesional
            }

        ]
            .filter(
                item =>
                    item.nombre !==
                    nombreCampo
            )
            .map(
                item =>
                    String(
                        item.valor ||
                        ''
                    )
                        .trim()
                        .toLowerCase()
            )
            .filter(
                Boolean
            );


        return otrosEmails
            .includes(
                valorNuevo
            );

    };


    /*
    ====================================
    GUARDAR CAMPO
    ====================================
    */

    const guardarCampo =
        async (
            nombreCampo,
            tipo = 'text'
        ) => {

            if (
                !paciente ||
                guardandoCampo
            ) {

                return;

            }


            if (
                CAMPOS_OBLIGATORIOS_CREACION
                    .has(
                        nombreCampo
                    ) &&
                String(
                    valorEdicion ??
                    ''
                )
                    .trim() === ''
            ) {

                setErrorCampo(
                    'Este campo es obligatorio'
                );


                return;

            }


            if (
                validarEmailDuplicado(
                    nombreCampo,
                    valorEdicion
                )
            ) {

                setErrorCampo(
                    'El email no puede coincidir con otro'
                );


                return;

            }


            let valorOriginal =
                paciente[
                    nombreCampo
                ];


            if (
                tipo === 'date'
            ) {

                valorOriginal =
                    convertirFechaParaInput(
                        valorOriginal
                    );

            }


            if (
                String(
                    valorOriginal ??
                    ''
                ) ===
                String(
                    valorEdicion ??
                    ''
                )
            ) {

                cancelarEdicion();


                return;

            }


            let valorBackend =
                valorEdicion;


            if (
                tipo === 'date' &&
                valorEdicion === ''
            ) {

                valorBackend =
                    null;

            }


            setGuardandoCampo(
                true
            );


            setErrorCampo(
                ''
            );


            const respuesta =
                await dispatch(
                    editarPacienteAction({

                        config,

                        payload: {

                            id_paciente:
                                paciente
                                    .id_paciente,

                            [nombreCampo]:
                                valorBackend

                        }

                    })
                );


            setGuardandoCampo(
                false
            );


            if (
                respuesta?.ok
            ) {

                setCampoEditando(
                    null
                );


                setValorEdicion(
                    ''
                );


                setErrorCampo(
                    ''
                );


                return;

            }


            setErrorCampo(

                respuesta
                    ?.error
                    ?.msg ||

                'No se pudo guardar el cambio'

            );

        };


    /*
    ====================================
    INICIAR EDICIÓN UBICACIÓN
    ====================================
    */

    const iniciarEdicionUbicacion = (
        nombreCampo,
        ubicacionActual
    ) => {

        if (
            guardandoCampo
        ) {

            return;

        }


        setCampoEditando(
            nombreCampo
        );


        setValorEdicion(
            ubicacionActual ||
            {}
        );


        setErrorCampo(
            ''
        );

    };


    /*
    ====================================
    GUARDAR UBICACIÓN
    ====================================
    */

    const guardarUbicacion =
        async (
            nombreCampo
        ) => {

            if (
                !paciente ||
                guardandoCampo
            ) {

                return;

            }


            const ubicacionActual =
                paciente[
                    nombreCampo
                ] ||
                {};


            if (
                JSON.stringify(
                    ubicacionActual
                ) ===
                JSON.stringify(
                    valorEdicion ||
                    {}
                )
            ) {

                cancelarEdicion();


                return;

            }


            setGuardandoCampo(
                true
            );


            setErrorCampo(
                ''
            );


            const respuesta =
                await dispatch(
                    editarPacienteAction({

                        config,

                        payload: {

                            id_paciente:
                                paciente
                                    .id_paciente,

                            [nombreCampo]:
                                valorEdicion ||
                                {}

                        }

                    })
                );


            setGuardandoCampo(
                false
            );


            if (
                respuesta?.ok
            ) {

                setCampoEditando(
                    null
                );


                setValorEdicion(
                    ''
                );


                setErrorCampo(
                    ''
                );


                return;

            }


            setErrorCampo(

                respuesta
                    ?.error
                    ?.msg ||

                'No se pudo guardar la ubicación'

            );

        };


    /*
    ====================================
    AYUDA DATOS MÍNIMOS
    ====================================
    */

    const mostrarAyudaInvitacion =
        () => {

            const textoDatosFaltantes =
                datosFaltantesInvitacion.length > 0
                    ?
                    `<p>
                        <strong>Completá:</strong>
                    </p>

                    <ul style="text-align:left;">
                        ${datosFaltantesInvitacion
                            .map(
                                dato => `<li>${dato}</li>`
                            )
                            .join('')}
                    </ul>`
                    :
                    `<p>
                        <strong>Todos los datos mínimos están completos.</strong>
                        Ya podés invitar al paciente.
                    </p>`;

            Swal.fire({

                title:
                    'Invitación del paciente',

                html: `
                    <div
                        style="
                            text-align:left;
                            line-height:1.6;
                        "
                    >

                        <p>
                            Para invitar al paciente
                            necesitás completar los
                            datos mínimos destacados.
                        </p>

                        ${textoDatosFaltantes}

                        <p>
                            Una vez enviada la invitación,
                            el enlace queda vigente durante
                            96 horas.
                        </p>

                        <p>
                            Mientras la invitación esté
                            vigente no se podrá generar
                            otra.
                        </p>

                        <p>
                            Cuando venza, aparecerá la
                            opción <strong>Reenviar invitación</strong>.
                        </p>

                        <p>
                            También podrás ver si el email
                            fue enviado, entregado,
                            rechazado o tuvo algún error.
                        </p>

                    </div>
                `,

                icon:
                    'info',

                confirmButtonText:
                    'Entendido',

                confirmButtonColor:
                    '#655EE8'

            });

        };


    /*
    ========================================
    DATOS FALTANTES INVITACIÓN
    ========================================
    */

    const datosFaltantesInvitacion =
        [];


    if (
        paciente &&
        !paciente.paciente_id &&
        !paciente.email_app
    ) {

        Object.entries(
            CAMPOS_MINIMOS_INVITACION
        ).forEach(
            ([
                campo,
                etiqueta
            ]) => {

                const valor =
                    paciente[
                        campo
                    ];


                const estaVacio =

                    valor === null ||

                    valor === undefined ||

                    String(
                        valor
                    ).trim() === '';


                if (
                    estaVacio
                ) {

                    datosFaltantesInvitacion
                        .push(
                            etiqueta
                        );

                }

            }
        );

    }


    /*
    ========================================
    ABRIR MODAL INVITACIÓN
    ========================================
    */

    const abrirModalInvitacion =
        () => {

        if (
            !paciente ||
            paciente.paciente_id ||
            paciente.email_app ||
            datosFaltantesInvitacion.length > 0
        ) {

            return;

        }


        /*
        Invitación vigente normal:
        no puede reenviarse.

        Invitación vigente cuyo email
        fue rechazado:
        sí puede reenviarse inmediatamente.
        */

        if (
            invitacionVigente &&
            !puedeReenviarInmediatamente
        ) {

            return;

        }


        setErrorInvitacion(
            ''
        );


        setModalInvitacionAbierto(
            true
        );

    };


    /*
    ========================================
    CERRAR MODAL INVITACIÓN
    ========================================
    */

    const cerrarModalInvitacion =
        () => {

            if (
                enviandoInvitacion
            ) {

                return;

            }


            setModalInvitacionAbierto(
                false
            );


            setErrorInvitacion(
                ''
            );

        };


    /*
    ========================================
    SOLICITAR VINCULACIÓN
    ========================================
    */

    const solicitarVinculacion =
        async () => {

            if (
                !paciente ||
                !paciente.email_app ||
                paciente.solicitud_tutor ||
                enviandoVinculacion
            ) {

                return;

            }


            setEnviandoVinculacion(
                true
            );


            setErrorVinculacion(
                ''
            );


            const respuesta =
                await dispatch(
                    solicitudNuevoProfesionalAction({

                        config,

                        payload: {

                            email:
                                paciente.email

                        }

                    })
                );


            setEnviandoVinculacion(
                false
            );


            if (
                !respuesta?.ok
            ) {

                setErrorVinculacion(

                    respuesta
                        ?.error
                        ?.msg ||

                    'No se pudo enviar la solicitud de vinculación'

                );


                return;

            }


            await dispatch(
                cargarPacientesAction({

                    config

                })
            );


            Swal.fire({

                icon:
                    'success',

                title:
                    'Solicitud enviada',

                text:
                    'La solicitud de vinculación fue registrada correctamente.',

                confirmButtonColor:
                    '#655EE8'

            });

        };


    /*
    ========================================
    CONFIRMAR INVITACIÓN
    ========================================
    */

    const confirmarInvitacion =
        async () => {

            if (
                !paciente ||
                enviandoInvitacion
            ) {

                return;

            }


            if (
                invitacionVigente &&
                !puedeReenviarInmediatamente
            ) {

                return;

            }


            setEnviandoInvitacion(
                true
            );


            setErrorInvitacion(
                ''
            );


            const respuesta =
                await dispatch(
                    enviarInvitacionPacienteAction({

                        config,

                        payload: {

                            id_paciente:
                                paciente.id_paciente

                        }

                    })
                );


            setEnviandoInvitacion(
                false
            );


            if (
                !respuesta?.ok
            ) {

                setErrorInvitacion(

                    respuesta
                        ?.error
                        ?.msg ||

                    'No se pudo enviar la invitación'

                );


                return;

            }


            setModalInvitacionAbierto(
                false
            );


            await dispatch(
                cargarPacientesAction({

                    config

                })
            );


            Swal.fire({

                icon:
                    'success',

                title:
                    invitacionVencida
                        ?
                        'Invitación reenviada'
                        :
                        'Invitación enviada',

                text:
                    `El enlace fue enviado a ${paciente.email}`,

                confirmButtonColor:
                    '#23AAAF'

            });

        };


    /*
    ====================================
    RENDER CAMPO
    ====================================
    */

    const renderCampo = (
        configuracionCampo
    ) => {

        const {

            nombre,
            label,
            tipo = 'text',
            opciones = [],
            editable = true,
            completo = false,
            obtenerValor

        } = configuracionCampo;


        const valor =
            obtenerValor
                ?
                obtenerValor(
                    paciente
                )
                :
                paciente[
                    nombre
                ];


        const esEditable =
            editable &&
            puedeEditarCampo(
                nombre
            );


        const esMinimoInvitacion =

            Boolean(
                paciente
            ) &&

            !paciente.paciente_id &&

            !paciente.email_app &&

            Object.prototype
                .hasOwnProperty
                .call(
                    CAMPOS_MINIMOS_INVITACION,
                    nombre
                );


        const estaVacio =

            valor === null ||

            valor === undefined ||

            String(
                valor
            ).trim() === '';


        const faltaMinimoInvitacion =

            esMinimoInvitacion &&

            estaVacio;


        return (

            <CampoEditablePaciente

                key={
                    nombre
                }

                nombre={
                    nombre
                }

                label={
                    label
                }

                valor={
                    valor
                }

                valorEdicion={
                    valorEdicion
                }

                tipo={
                    tipo
                }

                opciones={
                    opciones
                }

                editable={
                    esEditable
                }

                editando={
                    campoEditando ===
                    nombre
                }

                guardando={
                    guardandoCampo
                }

                destacado={
                    esMinimoInvitacion
                }

                faltante={
                    faltaMinimoInvitacion
                }

                completo={
                    completo
                }

                error={
                    campoEditando ===
                    nombre
                        ?
                        errorCampo
                        :
                        ''
                }

                onEditar={
                    () =>
                        iniciarEdicion(
                            nombre,
                            valor,
                            tipo
                        )
                }

                onCambiar={
                    setValorEdicion
                }

                onCancelar={
                    cancelarEdicion
                }

                onGuardar={
                    () =>
                        guardarCampo(
                            nombre,
                            tipo
                        )
                }

            />

        );

    };


    /*
    ====================================
    RENDER UBICACIÓN
    ====================================
    */

    const renderUbicacion = ({

        campo,
        titulo,

        paisLegacy,
        provinciaLegacy,
        departamentoLegacy,
        localidadLegacy

    }) => {

        const ubicacionActual =
            paciente[
                campo
            ];


        const resumen =
            obtenerResumenUbicacion({

                ubicacion:
                    ubicacionActual,

                paisLegacy,
                provinciaLegacy,
                departamentoLegacy,
                localidadLegacy

            });


        const editando =
            campoEditando ===
            campo;


        const editable =
            !paciente.paciente_id;


        return (

            <BloqueUbicacionDato>


                <EncabezadoUbicacionDato>

                    <TituloUbicacionDato>

                        {titulo}

                    </TituloUbicacionDato>


                    {
                        editable &&
                        !editando && (

                            <BotonEditarCampo

                                type="button"

                                title={
                                    `Editar ${titulo}`
                                }

                                aria-label={
                                    `Editar ${titulo}`
                                }

                                onClick={
                                    () =>
                                        iniciarEdicionUbicacion(
                                            campo,
                                            ubicacionActual
                                        )
                                }

                            >

                                ✎

                            </BotonEditarCampo>

                        )
                    }

                </EncabezadoUbicacionDato>


                {
                    editando
                        ?

                        <>

                            <SelectorUbicacion

                                value={
                                    valorEdicion ||
                                    {}
                                }

                                onChange={
                                    setValorEdicion
                                }

                                prefijo={
                                    `editar-${campo}`
                                }

                                disabled={
                                    guardandoCampo
                                }

                            />


                            <AccionesCampo>

                                <BotonCancelarCampo

                                    type="button"

                                    title="Cancelar"

                                    disabled={
                                        guardandoCampo
                                    }

                                    onClick={
                                        cancelarEdicion
                                    }

                                >

                                    ×

                                </BotonCancelarCampo>


                                <BotonConfirmarCampo

                                    type="button"

                                    title="Guardar ubicación"

                                    disabled={
                                        guardandoCampo
                                    }

                                    onClick={
                                        () =>
                                            guardarUbicacion(
                                                campo
                                            )
                                    }

                                >

                                    {
                                        guardandoCampo
                                            ?
                                            '…'
                                            :
                                            '✓'
                                    }

                                </BotonConfirmarCampo>

                            </AccionesCampo>


                            {
                                errorCampo && (

                                    <TextoErrorDato>

                                        {errorCampo}

                                    </TextoErrorDato>

                                )
                            }

                        </>

                        :

                        (
                            resumen.length > 0
                                ?

                                <ResumenUbicacion>

                                    {
                                        resumen.map(
                                            (
                                                item,
                                                index
                                            ) => (

                                                <ItemUbicacion

                                                    key={
                                                        `${campo}-${index}-${item}`
                                                    }

                                                >

                                                    {item}

                                                </ItemUbicacion>

                                            )
                                        )
                                    }

                                </ResumenUbicacion>

                                :

                                <UbicacionVacia>

                                    Sin ubicación cargada

                                </UbicacionVacia>
                        )
                }


            </BloqueUbicacionDato>

        );

    };


    /*
    ====================================
    PACIENTE NO DISPONIBLE
    ====================================
    */

    if (
        !paciente
    ) {

        return (

            <ContenedorPrincipal>

                <HeaderUno />


                <HeaderDos

                    link="/escritorio/pacientes/paciente"

                    componente="Datos paciente"

                    paciente={
                        false
                    }

                />


                <ContenedorDatosPaciente>

                    <TextoSeccionDatos>

                        No se encontró la información
                        del paciente seleccionado.

                    </TextoSeccionDatos>

                </ContenedorDatosPaciente>


            </ContenedorPrincipal>

        );

    }


    /*
    ====================================
    RENDER PRINCIPAL
    ====================================
    */

    return (

        <ContenedorPrincipal>


            <HeaderUno />


            <HeaderDos

                link="/escritorio/pacientes/paciente"

                componente="Datos paciente"

                paciente={
                    false
                }

            />


            <ContenedorDatosPaciente>


                {
                    alerta
                        ?
                        <Alertas />
                        :
                        null
                }


                {/* =====================================
                    ENCABEZADO
                ====================================== */}

                <EncabezadoPaciente>


                    <InfoPacienteSuperior>


                        {
                            paciente
                                .profesional_tratamiento && (

                                <DatoSuperior>

                                    Profesional que lo trata:{' '}

                                    <strong>

                                        {
                                            paciente
                                                .profesional_tratamiento
                                        }

                                    </strong>

                                </DatoSuperior>

                            )
                        }


                        <DatoSuperior>

                            Paciente:{' '}

                            <strong>

                                {
                                    paciente.nombre
                                }{' '}

                                {
                                    paciente.apellido
                                }

                            </strong>

                        </DatoSuperior>


                    </InfoPacienteSuperior>


                    <EstadoPaciente

                        $completo={
                            Boolean(
                                paciente
                                    .paciente_id
                            )
                        }

                    >

                        {
                            paciente.servicio ||
                            'Paciente'
                        }

                    </EstadoPaciente>


                </EncabezadoPaciente>


                {/* =====================================
                    INVITACIÓN / VINCULACIÓN
                ====================================== */}

                {
                    !paciente
                        .paciente_id && (

                        <AvisoDatosYogen

                            $incompleto={
                                !paciente.email_app &&
                                !invitacionVigente &&
                                !invitacionVencida &&
                                datosFaltantesInvitacion.length > 0
                            }

                            $vinculacion={
                                Boolean(
                                    paciente.email_app
                                )
                            }

                            $invitacionVigente={
                                invitacionVigente
                            }

                            $invitacionVencida={
                                invitacionVencida
                            }

                            $errorEmail={
                                invitacionVigente &&
                                infoEstadoEmail
                                    ?.tipo ===
                                    'error'
                            }

                        >


                            {/* =================================
                                TEXTO PRINCIPAL
                            ================================== */}

                            {
                                paciente.email_app
                                    ?

                                    /*
                                    ====================================
                                    PACIENTE YA EXISTENTE EN YÖGEN
                                    ====================================
                                    */

                                    <TextoAvisoYogen>

                                        <strong>

                                            Este paciente ya posee
                                            una cuenta en YÖGEN.

                                        </strong>

                                        {' '}

                                        {
                                            paciente.solicitud_tutor
                                                ?
                                                'La solicitud de vinculación ya fue enviada.'
                                                :
                                                'Podés solicitar a la familia la vinculación con este profesional.'
                                        }

                                    </TextoAvisoYogen>


                                    :

                                invitacionVigente
                                    ?

                                    /*
                                    ====================================
                                    INVITACIÓN VIGENTE
                                    ====================================
                                    */

                                    <TextoAvisoYogen>


                                        {
                                            emailRechazado
                                                ?

                                                <>

                                                    <strong>

                                                        El email fue rechazado.

                                                    </strong>

                                                    {' '}

                                                    El servidor de destino
                                                    no aceptó el correo.
                                                    Esto no necesariamente
                                                    significa que la dirección
                                                    sea incorrecta. Podés
                                                    revisarla o intentar
                                                    enviarla nuevamente.

                                                </>

                                                :

                                            emailInvalido
                                                ?

                                                <>

                                                    <strong>

                                                        El email es inválido.

                                                    </strong>

                                                    {' '}

                                                    Revisá y corregí la
                                                    dirección antes de volver
                                                    a enviar la invitación.

                                                </>

                                                :

                                            emailSpam
                                                ?

                                                <>

                                                    <strong>

                                                        El email fue marcado
                                                        como spam.

                                                    </strong>

                                                    {' '}

                                                    No recomendamos volver
                                                    a enviarlo a esta dirección
                                                    sin contactar primero a
                                                    la persona por otro medio.

                                                </>

                                                :

                                                <>

                                                    <strong>

                                                        Paciente invitado.

                                                    </strong>

                                                    {' '}

                                                    La invitación se encuentra
                                                    vigente por{' '}

                                                    <strong>

                                                        {
                                                            horasInvitacionRestantes
                                                        }{' '}

                                                        {
                                                            horasInvitacionRestantes === 1
                                                                ?
                                                                'hora'
                                                                :
                                                                'horas'
                                                        }.

                                                    </strong>

                                                </>
                                        }


                                    </TextoAvisoYogen>


                                    :

                                invitacionVencida
                                    ?

                                    /*
                                    ====================================
                                    INVITACIÓN VENCIDA
                                    ====================================
                                    */

                                    <TextoAvisoYogen>

                                        <strong>

                                            Invitación vencida.

                                        </strong>

                                        {' '}

                                        El enlace anterior ya no
                                        puede utilizarse. Podés
                                        enviar una nueva invitación.

                                    </TextoAvisoYogen>


                                    :

                                    /*
                                    ====================================
                                    TODAVÍA NO INVITADO
                                    ====================================
                                    */

                                    <TextoAvisoYogen>

                                        <strong>

                                            Datos mínimos para
                                            invitar al paciente:

                                        </strong>

                                        {' '}

                                        {
                                            datosFaltantesInvitacion
                                                .length > 0
                                                ?

                                                `Faltan ${
                                                    datosFaltantesInvitacion.length
                                                } ${
                                                    datosFaltantesInvitacion.length === 1
                                                        ?
                                                        'dato'
                                                        :
                                                        'datos'
                                                }: ${
                                                    datosFaltantesInvitacion
                                                        .join(', ')
                                                }`

                                                :

                                                'Todos los datos mínimos están completos'
                                        }

                                    </TextoAvisoYogen>
                            }


                            {/* =================================
                                BOTONES
                            ================================== */}

                            <AccionesAvisoDatosYogen>


                                {
                                    paciente.email_app
                                        ?

                                        /*
                                        ====================================
                                        CUENTA EXISTENTE
                                        ====================================
                                        */

                                        (
                                            !paciente.solicitud_tutor && (

                                                <BotonSolicitarVinculacion

                                                    type="button"

                                                    disabled={
                                                        enviandoVinculacion
                                                    }

                                                    onClick={
                                                        solicitarVinculacion
                                                    }

                                                >

                                                    {
                                                        enviandoVinculacion
                                                            ?
                                                            'Enviando...'
                                                            :
                                                            'Solicitar vinculación'
                                                    }

                                                </BotonSolicitarVinculacion>

                                            )
                                        )


                                        :

                                    invitacionVigente
                                        ?

                                        /*
                                        ====================================
                                        INVITACIÓN VIGENTE
                                        ====================================
                                        */

                                        (
                                            emailRechazado
                                                ?

                                                /*
                                                ====================================
                                                RECHAZADO / REBOTADO

                                                Permitimos:
                                                - editar email;
                                                - reenviar al mismo email.
                                                ====================================
                                                */

                                                <>

                                                    <BotonInvitarPaciente

                                                        type="button"

                                                        onClick={
                                                            () =>
                                                                iniciarEdicion(
                                                                    'email',
                                                                    paciente.email,
                                                                    'email'
                                                                )
                                                        }

                                                    >

                                                        Editar email

                                                    </BotonInvitarPaciente>


                                                    <BotonInvitarPaciente

                                                        type="button"

                                                        onClick={
                                                            abrirModalInvitacion
                                                        }

                                                    >

                                                        Reenviar invitación

                                                    </BotonInvitarPaciente>

                                                </>


                                                :

                                            emailInvalido
                                                ?

                                                /*
                                                ====================================
                                                EMAIL INVÁLIDO

                                                Acá sí obligamos a corregir.
                                                ====================================
                                                */

                                                <BotonInvitarPaciente

                                                    type="button"

                                                    onClick={
                                                        () =>
                                                            iniciarEdicion(
                                                                'email',
                                                                paciente.email,
                                                                'email'
                                                            )
                                                    }

                                                >

                                                    Corregir email

                                                </BotonInvitarPaciente>


                                                :

                                            emailSpam
                                                ?

                                                /*
                                                ====================================
                                                SPAM

                                                No permitimos reenvío inmediato.
                                                ====================================
                                                */

                                                <BotonInvitarPaciente

                                                    type="button"

                                                    disabled

                                                >

                                                    Envío bloqueado

                                                </BotonInvitarPaciente>


                                                :

                                                /*
                                                ====================================
                                                INVITACIÓN NORMAL VIGENTE
                                                ====================================
                                                */

                                                <BotonInvitarPaciente

                                                    type="button"

                                                    disabled

                                                >

                                                    Paciente invitado

                                                </BotonInvitarPaciente>
                                        )


                                        :

                                    /*
                                    ====================================
                                    SIN INVITACIÓN VIGENTE
                                    ====================================
                                    */

                                    <BotonInvitarPaciente

                                        type="button"

                                        disabled={
                                            datosFaltantesInvitacion.length > 0
                                        }

                                        title={
                                            datosFaltantesInvitacion.length > 0
                                                ?
                                                `Para invitar al paciente, completá los siguientes datos: ${datosFaltantesInvitacion.join(', ')}.`
                                                :
                                                'Enviar invitación al paciente'
                                        }

                                        onClick={
                                            abrirModalInvitacion
                                        }

                                    >

                                        {
                                            invitacionVencida ||
                                            tieneHistorialInvitacion
                                                ?
                                                'Reenviar invitación'
                                                :
                                                'Invitar paciente'
                                        }

                                    </BotonInvitarPaciente>

                                }


                                {
                                    !paciente.email_app && (

                                        <BotonAyudaDatos

                                            type="button"

                                            title="¿Qué significa?"

                                            aria-label="Información sobre la invitación"

                                            onClick={
                                                mostrarAyudaInvitacion
                                            }

                                        >

                                            ?

                                        </BotonAyudaDatos>

                                    )
                                }


                            </AccionesAvisoDatosYogen>


                            {/* =================================
                                ESTADO REAL DEL EMAIL
                            ================================== */}

                            {
                                tieneHistorialInvitacion && (

                                    <EstadoInvitacionBox

                                        $tipo={
                                            invitacionVencida
                                                ?
                                                'vencida'
                                                :
                                                infoEstadoEmail
                                                    ?.tipo ||
                                                'neutral'
                                        }

                                    >


                                        <CabeceraEstadoInvitacion>


                                            <TituloEstadoInvitacion>

                                                {
                                                    invitacionVencida
                                                        ?
                                                        'Última invitación'
                                                        :
                                                        'Estado del email'
                                                }

                                            </TituloEstadoInvitacion>


                                            <BadgeEstadoInvitacion

                                                $tipo={
                                                    invitacionVencida
                                                        ?
                                                        'vencida'
                                                        :
                                                        infoEstadoEmail
                                                            ?.tipo ||
                                                        'neutral'
                                                }

                                            >

                                                {
                                                    invitacionVencida
                                                        ?
                                                        'Invitación vencida'
                                                        :
                                                        infoEstadoEmail
                                                            ?.titulo ||
                                                        'Invitación registrada'
                                                }

                                            </BadgeEstadoInvitacion>


                                        </CabeceraEstadoInvitacion>


                                        {
                                            emailUltimaInvitacion && (

                                                <EmailEstadoInvitacion>

                                                    {
                                                        emailUltimaInvitacion
                                                    }

                                                </EmailEstadoInvitacion>

                                            )
                                        }


                                        <DetalleEstadoInvitacion>


                                            {
                                                invitacionVencida
                                                    ?

                                                    <>

                                                        El enlace de esta
                                                        invitación ya no es
                                                        válido.

                                                        {
                                                            infoEstadoEmail
                                                                ?.titulo && (

                                                                <>

                                                                    {' '}

                                                                    Último estado
                                                                    del correo:{' '}

                                                                    <strong>

                                                                        {
                                                                            infoEstadoEmail
                                                                                .titulo
                                                                        }

                                                                    </strong>.

                                                                </>

                                                            )
                                                        }

                                                    </>


                                                    :

                                                emailRechazado
                                                    ?

                                                    <>

                                                        {
                                                            infoEstadoEmail
                                                                ?.detalle ||
                                                            'El servidor de destino rechazó el correo.'
                                                        }

                                                        {' '}

                                                        Podés revisar la
                                                        dirección o volver
                                                        a intentar el envío
                                                        al mismo email.

                                                    </>


                                                    :

                                                    infoEstadoEmail
                                                        ?.detalle ||
                                                    'Existe un registro de envío para esta invitación.'
                                            }


                                        </DetalleEstadoInvitacion>


                                        {
                                            invitacionVigente && (

                                                <MetaEstadoInvitacion>

                                                    Invitación vigente por{' '}

                                                    {
                                                        horasInvitacionRestantes
                                                    }{' '}

                                                    {
                                                        horasInvitacionRestantes === 1
                                                            ?
                                                            'hora'
                                                            :
                                                            'horas'
                                                    }.

                                                </MetaEstadoInvitacion>

                                            )
                                        }


                                    </EstadoInvitacionBox>

                                )
                            }


                            {
                                errorVinculacion && (

                                    <TextoErrorDato>

                                        {
                                            errorVinculacion
                                        }

                                    </TextoErrorDato>

                                )
                            }


                        </AvisoDatosYogen>

                    )
                }


                {/* =====================================
                    TARJETA DATOS
                ====================================== */}

                <TarjetaDatosPaciente>


                    {/* =================================
                        DATOS DEL PACIENTE
                    ================================== */}

                    <SeccionDatosPaciente>


                        <EncabezadoSeccionDatos>

                            <TituloSeccionDatos>

                                Datos del paciente

                            </TituloSeccionDatos>

                        </EncabezadoSeccionDatos>


                        <GridDatosPaciente>

                            {
                                CAMPOS_DATOS_PACIENTE
                                    .map(
                                        renderCampo
                                    )
                            }

                        </GridDatosPaciente>


                    </SeccionDatosPaciente>


                    <SeparadorDatosPaciente />


                    {/* =================================
                        DOMICILIO
                    ================================== */}

                    <SeccionDatosPaciente>


                        <TituloSeccionDatos>

                            Domicilio

                        </TituloSeccionDatos>


                        {
                            renderUbicacion({

                                campo:
                                    'ubicacion',

                                titulo:
                                    'Ubicación',

                                paisLegacy:
                                    paciente.pais,

                                provinciaLegacy:
                                    paciente.provincia,

                                departamentoLegacy:
                                    paciente.departamento,

                                localidadLegacy:
                                    paciente.localidad

                            })
                        }


                        <GridDatosPaciente>

                            {
                                renderCampo({

                                    nombre:
                                        'direccion',

                                    label:
                                        'Dirección',

                                    completo:
                                        true

                                })
                            }

                        </GridDatosPaciente>


                    </SeccionDatosPaciente>


                    <SeparadorDatosPaciente />


                    {/* =================================
                        ESCOLARIDAD
                    ================================== */}

                    <SeccionDatosPaciente>


                        <TituloSeccionDatos>

                            Escolaridad

                        </TituloSeccionDatos>


                        <GridDatosPaciente>

                            {
                                CAMPOS_ESCOLARIDAD
                                    .map(
                                        renderCampo
                                    )
                            }

                        </GridDatosPaciente>


                    </SeccionDatosPaciente>


                    <SeparadorDatosPaciente />


                    {/* =================================
                        COBERTURA MÉDICA
                    ================================== */}

                    <SeccionDatosPaciente>


                        <TituloSeccionDatos>

                            Cobertura médica

                        </TituloSeccionDatos>


                        <GridDatosPaciente>

                            {
                                CAMPOS_COBERTURA
                                    .map(
                                        renderCampo
                                    )
                            }

                        </GridDatosPaciente>


                    </SeccionDatosPaciente>


                    <SeparadorDatosPaciente />


                    {/* =================================
                        INFORMACIÓN CLÍNICA
                    ================================== */}

                    <SeccionDatosPaciente>


                        <EncabezadoSeccionDatos>

                            <div>

                                <TituloSeccionDatos>

                                    Información clínica

                                </TituloSeccionDatos>


                                <TextoSeccionDatos>

                                    Esta información puede
                                    actualizarse mientras el
                                    paciente continúe como
                                    administrativo.

                                </TextoSeccionDatos>

                            </div>

                        </EncabezadoSeccionDatos>


                        <GridDatosPaciente>

                            {
                                CAMPOS_CLINICOS
                                    .map(
                                        renderCampo
                                    )
                            }

                        </GridDatosPaciente>


                    </SeccionDatosPaciente>


                    <SeparadorDatosPaciente />


                    {/* =================================
                        TUTORES
                    ================================== */}

                    <SeccionDatosPaciente>


                        <TituloSeccionDatos>

                            Datos padres / tutores

                        </TituloSeccionDatos>


                        <CabeceraTutoresDatos>

                            <span>
                                TUTOR 1
                            </span>

                            <span>
                                TUTOR 2
                            </span>

                        </CabeceraTutoresDatos>


                        <GridDatosPaciente>

                            {
                                CAMPOS_TUTORES
                                    .map(
                                        renderCampo
                                    )
                            }

                        </GridDatosPaciente>


                        {/* =================================
                            DOMICILIO TUTOR 1
                        ================================== */}

                        {
                            renderUbicacion({

                                campo:
                                    'ubicacion_1',

                                titulo:
                                    'Domicilio Tutor 1',

                                paisLegacy:
                                    paciente.pais_1,

                                provinciaLegacy:
                                    paciente.provincia_1,

                                departamentoLegacy:
                                    paciente.departamento_1,

                                localidadLegacy:
                                    paciente.localidad_1

                            })
                        }


                        <GridDatosPaciente>

                            {
                                renderCampo({

                                    nombre:
                                        'direccion_1',

                                    label:
                                        'Dirección Tutor 1',

                                    completo:
                                        true

                                })
                            }

                        </GridDatosPaciente>


                        {/* =================================
                            DOMICILIO TUTOR 2
                        ================================== */}

                        {
                            renderUbicacion({

                                campo:
                                    'ubicacion_2',

                                titulo:
                                    'Domicilio Tutor 2',

                                paisLegacy:
                                    paciente.pais_2,

                                provinciaLegacy:
                                    paciente.provincia_2,

                                departamentoLegacy:
                                    paciente.departamento_2,

                                localidadLegacy:
                                    paciente.localidad_2

                            })
                        }


                        <GridDatosPaciente>

                            {
                                renderCampo({

                                    nombre:
                                        'direccion_2',

                                    label:
                                        'Dirección Tutor 2',

                                    completo:
                                        true

                                })
                            }

                        </GridDatosPaciente>


                    </SeccionDatosPaciente>


                    <SeparadorDatosPaciente />


                    {/* =================================
                        CÓMO CONOCIERON YÖGEN
                    ================================== */}

                    <SeccionDatosPaciente>


                        <GridDatosPaciente>

                            {
                                renderCampo({

                                    nombre:
                                        'conocieron',

                                    label:
                                        '¿Cómo conocieron YÖGEN?',

                                    completo:
                                        true

                                })
                            }

                        </GridDatosPaciente>


                    </SeccionDatosPaciente>


                </TarjetaDatosPaciente>


            </ContenedorDatosPaciente>


            {/* =====================================
                MODAL INVITACIÓN
            ====================================== */}

            <ModalInvitarPaciente

                abierto={
                    modalInvitacionAbierto
                }

                email={
                    paciente.email
                }

                enviando={
                    enviandoInvitacion
                }

                error={
                    errorInvitacion
                }

                onCerrar={
                    cerrarModalInvitacion
                }

                onConfirmar={
                    confirmarInvitacion
                }

            />


        </ContenedorPrincipal>

    );

};


export default DatosPaciente;